/* file description */
import './index.less';
import { AssetTaskTable } from './asset/AssetTaskTable';

export { default as SPTableWithModel } from '@/components/SPTableWithModel';
export { default as LcpTableWithModel } from '@/components/SPTableWithModel';
export * from './asset/AssetTask';
export * from './asset/AssetTaskTable';
export * from './asset/AssetAdd';
export * from './asset/AssetField';
export * from './asset/AssetModuleTable';
export * from './asset/AssetModuleForm';
export { default as SPCentre } from '@/asset/AssetTask/templates/Cascade';
// export { default as SPListEntry } from '@/components/sp-list-entry'; // 后续不再暴露
export { AssetTaskTable as SPListEntry }; // 临时将 AssetTaskTable 作为 SPListEntry 暴露
export { default as SPGroupForm } from '@/components/SPGroupForm';
export { default as LcpGroupForm } from '@/components/SPGroupForm';
export { default as SPTableBase } from '@/components/SPTableBase';
// export * from './asset/AssetField';

export const version = '1.0.0-v20230625';
